import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from "@angular/core";
import * as Diff from "diff";

@Directive({
	selector: "[historyDiff]",
	standalone: true,
})
export class HistoryDiffDirective implements OnChanges {
	@Input() oldValue: string = "";
	@Input() newValue: string = "";

	constructor(private el: ElementRef, private renderer: Renderer2) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.oldValue || changes.newValue) {
			this.applyDiff();
		}
	}

	private applyDiff(): void {
		// Get the diff between the old and new values
		const oldValue = this.oldValue || "";
		const newValue = this.newValue || "";
		const diffParts = Diff.diffWords(oldValue, newValue);

		// Clear the element's existing content
		this.el.nativeElement.innerHTML = "";

		const phoneNumber = this.isPhoneNumber(oldValue, newValue);
		const isCommaDelimited = this.isCommaDelimitedList(oldValue, newValue);

		diffParts.forEach((part) => {
			const span = this.renderer.createElement("span");
			const text = this.renderer.createText(part.value.join ? part.value.join(", ") : part.value);

			if (part.added) {
				this.renderer.setStyle(span, "background-color", "#d4fcbc");
				if ((oldValue.length < 100 && newValue.length < 100) || phoneNumber) {
					this.renderer.setStyle(span, "padding", "0 2px");
					this.renderer.setStyle(span, "display", "inline");
				}
			} else if (part.removed) {
				this.renderer.setStyle(span, "background-color", "#fbb6c2");
				if ((!isCommaDelimited && oldValue.length < 100 && newValue.length < 100) || phoneNumber) {
					this.renderer.setStyle(span, "padding", "0 2px");
					this.renderer.setStyle(span, "display", "inline");
				}
				this.renderer.setStyle(span, "text-decoration", "line-through");
			} else if (
				(!isCommaDelimited && oldValue.length < 100 && newValue.length < 100) ||
				phoneNumber
			) {
				this.renderer.setStyle(span, "display", "inline");
			}

			this.renderer.appendChild(span, text);
			this.renderer.appendChild(this.el.nativeElement, span);
		});
	}

	private isPhoneNumber(oldValue: string, newValue: string): boolean {
		const phoneRegex = /^[\d\+\-\(\)\s]+$/;
		return phoneRegex.test(oldValue) && phoneRegex.test(newValue);
	}

	private isCommaDelimitedList(oldValue: string, newValue: string): boolean {
		const maxItemLength = 40; // Increased max length of an item to handle longer list entries
		const maxWordsPerItem = 6; // Increased max words per item to allow descriptive list items

		// Split by commas and trim spaces
		const oldItems = oldValue.split(",").map((item) => item.trim());
		const newItems = newValue.split(",").map((item) => item.trim());

		const isSentence = (items: string[]) => {
			return items.some(
				(item) => item.length > maxItemLength || item.split(" ").length > maxWordsPerItem
			);
		};

		const isLikelyList = (items: string[]) => {
			const hyphenPattern = /-/;
			return items.every((item) => item.length <= maxItemLength || hyphenPattern.test(item));
		};

		if (isSentence(oldItems) || isSentence(newItems) || !isLikelyList(newItems)) {
			return false;
		}

		return true;
	}
}
